const excelbutton = () => ({
  button: {
    width: "100%",
    height: "37px",
    fontSize: "14px",
    overflow: "auto",
    border: "1px solid #aaa",
    backgroundColor: "#00733b",
    color: "#fff",
    borderRadius: "4px",
    lineHeight: "1.75",
  },
});

export default excelbutton;
